
import Vue from "vue";
import LogoIcon from "@/components/icons/LogoIcon.vue";
import HorizontalDivider from "@/components/HorizontalDivider.vue";
import FooterLayout from "@/components/FooterLayout.vue";

declare interface ComponentData {
  windowWidth: number;
}

export default Vue.extend({
  data(): ComponentData {
    return {
      windowWidth: window.innerWidth,
    };
  },
  components: { HorizontalDivider, LogoIcon, FooterLayout },
});
